<div class="environment-mode-toggle" role="group" aria-label="Go live mode">
  <button type="button" class="environment-mode-toggle__label"
    [class.environment-mode-toggle__label--active]="store.mode() === 'sandbox'" [disabled]="store.switching()"
    (click)="selectMode('sandbox')">
    Sandbox Mode
  </button>

  <button type="button" class="environment-mode-toggle__switch" role="switch"
    [attr.aria-checked]="store.mode() === 'live'" aria-label="Toggle go live on or off"
    [class.environment-mode-toggle__switch--live]="store.mode() === 'live'"
    [class.environment-mode-toggle__switch--sandbox]="store.mode() === 'sandbox'" [disabled]="store.switching()"
    (click)="toggleSwitch()">
    <span class="environment-mode-toggle__thumb" aria-hidden="true"></span>
  </button>

  <button type="button" class="environment-mode-toggle__label"
    [class.environment-mode-toggle__label--active]="store.mode() === 'live'"
    [class.environment-mode-toggle__label--primary]="store.mode() === 'live'" [disabled]="store.switching()"
    (click)="selectMode('live')">
    Go Live ON
  </button>
</div>